import { type RefObject, useEffect } from 'react';

export const useVideoSourceReload = (videoRef: RefObject<HTMLVideoElement>, src?: string) => {
    // Browsers don't pick up a changed <source src> on an already-loaded
    // <video> without an explicit reload - needed when src flips across
    // the mobile/desktop breakpoint.
    useEffect(() => {
        videoRef.current?.load();
    }, [src]);
};
